import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import jwtDecode from 'jwt-decode';
export var OPERA_COMPANY_ID = 'https://premierinn.com/operaCompanyId';
export var CDH_COMPANY_ID = 'https://premierinn.com/companyAccountId';
export var CDH_EMPLOYEE_ID = 'https://premierinn.com/employeeAccountId';
export var CDH_CUSTOMER_ID = 'https://premierinn.com/customerAccountId';
export default function getLoggedInUserInfo(token) {
  var decodedToken = {
    name: '',
    profile: {
      accessLevel: '',
      companyId: '',
      employeeId: '',
      isBusiness: '',
      sessionId: ''
    },
    [CDH_COMPANY_ID]: '',
    [CDH_EMPLOYEE_ID]: '',
    [OPERA_COMPANY_ID]: '',
    [CDH_CUSTOMER_ID]: ''
  };
  var cdhCompanyId = '';
  var cdhEmployeeId = '';
  var operaCompanyId = '';
  var cdhCustomerId = '';
  try {
    if (token !== null && token !== void 0 && token.length) {
      decodedToken = jwtDecode(token);
      cdhCompanyId = decodedToken[CDH_COMPANY_ID];
      cdhEmployeeId = decodedToken[CDH_EMPLOYEE_ID];
      operaCompanyId = decodedToken[OPERA_COMPANY_ID];
      cdhCustomerId = decodedToken[CDH_CUSTOMER_ID];
    }
  } catch (e) {
    console.log(e);
  }
  return _objectSpread(_objectSpread(_objectSpread({}, decodedToken), decodedToken.profile), {}, {
    cdhCompanyId,
    cdhEmployeeId,
    operaCompanyId,
    cdhCustomerId
  });
}